// NOTE: The whole purpose of this file is to help with unit testing since
// jest can't work with import.meta.env
// Vitest is able to work with it, maybe we should replace Jest with Vitest.
export const VITE_APP_BASE_ENDPOINT = import.meta.env.VITE_APP_BASE_ENDPOINT;
export const VITE_APP_LS_EXPIRY_TIME = import.meta.env.VITE_APP_LS_EXPIRY_TIME;
export const VITE_APP_CUSTOMER = import.meta.env.VITE_APP_CUSTOMER;